import _ from 'underscore';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IRouterRelatedProps } from '../types';

export function verifyRouter<P extends object>(Component: React.ComponentType<P>): React.FC<P & IRouterRelatedProps> {
  const ComponentWithRouter = withRouter<
    P & RouteComponentProps,
    React.ComponentType<P & RouteComponentProps>
  >(Component as React.ComponentType<P & RouteComponentProps>);

  const RouterWrapper: React.FC<P & IRouterRelatedProps> = (props) => {
    const {
      location = undefined,
      history = undefined,
    } = props;
    if (_.isEmpty(location) || _.isEmpty(history)) {
      return (
        <ComponentWithRouter
          {...props as unknown as React.ComponentProps<typeof ComponentWithRouter>}
        />
      );
    }

    return (<Component {...props} />);
  };

  return RouterWrapper;
}
